(function () {
	'use strict';

	angular.module('smb-app.app', [
			'smb-app'
		])
		.run([
			'$rootScope', 
			'$state', 
			'$injector', 
			'pxAuthService', 
			'smbPanelDetailsDataStore',
			function ($rootScope, $state, $injector, pxAuthService, smbPanelDetailsDataStore) {
			
			$rootScope.$on('$stateChangeStart', function (e, to) {
				// closes side panel for any route that does not explicitly
				// support side panel, this makes sure side panels get closed
				// on state changes
				if (!(to.data && to.data.hasSidePanel)) {
					smbPanelDetailsDataStore.reset();
				}

				var rule = to.data ? to.data.rule : null;
				var redirect;

				// If user is not authenticated, they can only reach the login and register states
				if (!pxAuthService.isAuthenticated && !(to.parent === 'loginComponent' || to.name === 'register')) {
					redirect = {
						to: 'login'
					};
				} else if (angular.isFunction(rule)) {
					redirect = rule($injector);
				}

				if (redirect && redirect.to !== to.name) {
					e.preventDefault();
					$state.go(redirect.to, redirect.params, { reload: redirect.to === $state.current.name });
				}
			});
		}])
		.config([
			'$urlRouterProvider',
			'$stateProvider',
			'$httpProvider',
			'pxAppIdentifierInterceptorProvider',
			function ($urlRouterProvider, $stateProvider, $httpProvider, pxAppIdentifierInterceptorProvider) {
				pxAppIdentifierInterceptorProvider.setAppId('AirBase');

				if (!$httpProvider.defaults.headers.get) {
					$httpProvider.defaults.headers.get = {};
				}

				//disable IE ajax request caching
    			$httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';

				//http intercepetors
				$httpProvider.interceptors.push('pxAuthInterceptor');
				$httpProvider.interceptors.push('pxAppIdentifierInterceptor');
				
				// defualt state
				$urlRouterProvider.otherwise('/');

				//state definitions
				$stateProvider
					.state('register', {
						url: '/register/:deploymentId?auth',
						views: {
							main: {
								template: function(params) {
									return '<smb-register deployment-id="' + params.deploymentId + '" auth-token="' + params.auth + '"></smb-register>';
								}
							}
						}
					})
					.state('loginComponent', {
						abstract: true,
						url: '',
						views: {
							'main': { template: '<smb-login />' }
						}
					})
					.state('content', {
						abstract: true,
						url: '/',
						views: {
							'main': { template: '<smb-main></smb-main>' }
						}
					})
					.state('content.home', {
						url: '',
						views: {
							'app': { template: '<smb-home></smb-home>' }
						}
					})
					.state('useradmin', {
						abstract: true,
						url: '/useradmin',
						views: {
							'main': { template: '<smb-main></smb-main>' }
						},
						data: {
							rule: inject(['pxAuthService', function (pxAuthService) {
								// only site admins and user admins can access these pages
								if (!pxAuthService.isSiteAdmin && !pxAuthService.isUserAdmin) {
									return {
										to: 'content.home'
									};
								}
							}])
						}
					})
					.state('useradmin.home', {
						url: '',
						views: {
							'app': { template: '<smb-user-administration/>' }
						}
					})
					.state('useradmin.home.usergroups', {
						url: '/usergroups',
						views: {
							'app@useradmin': { template: '<smbadmin-user-groups layout-fill />' }
						}
					})
					.state('useradmin.home.usergroups.details', {
						url: '/:usergroupId',
						views: {
							'app@useradmin': {
								template: function (params) {
									return '<smbadmin-user-group flex user-group-id="' + params.usergroupId + '" layout-fill />';
								}
							}
						}
					})
					.state('useradmin.home.users', {
						url: '/users',
						views: {
							'app@useradmin': { template: '<smbadmin-users layout-fill />' }
						}
					})
					.state('useradmin.home.users.details', {
						url: '/:userId',
						views: {
							'app@useradmin': {
								template: function (params) {
									return '<smbadmin-user flex user-id="' + params.userId + '" layout-fill />';
								}
							}
						}
					})
					.state('contentConfig', {
						abstract: true,
						url: '/contentconfiguration',
						views: {
							'main': { template: '<smb-main></smb-main>' }
						},
						data: {
							rule: inject(['pxAuthService', function (pxAuthService) {
								// only site admins can access content configuration
								if (!pxAuthService.isSiteAdmin) {
									return {
										to: 'content.home'
									};
								}
							}])
						}
					})
					.state('contentConfig.groups', {
						url: '/contenttypegroups',
						views: {
							'app': { template: '<smb-content-type-groups-config />' }
						}
					})
					.state('contentConfig.groups.details', {
						url: '/:groupId',
						views: {
							'app@contentConfig': { template: function (params) { return '<smb-content-type-group-config group-id="' + params.groupId + '" />'; } }
						}
					})
					.state('contentConfig.types', {
						url: '/contenttypegroups/:groupId/contenttypes',
						views: {
							'app': {
								template: function (params) { return '<smb-content-types-config content-type-group-id="' + params.groupId + '" />'; }
							}
						}
					})
					.state('contentConfig.types.details', {
						url: '/:typeId',
						views: {
							'app@contentConfig': {
								template: function (params) { return '<smb-content-type-config content-type-group-id="' + params.groupId + '" content-type-id="' + params.typeId + '" />'; }
							}
						}
					})
					.state('documentTrash', {
						abstract: true,
						url: '/trash',
						views: {
							'main': { template: '<smb-main></smb-main>' }
						},
						data: {
							rule: inject(['pxAuthService', function (pxAuthService) {
								var privs = pxAuthService.privileges;
								var hasTrashPriv = privs.core && privs.core.trash ?
									privs.core.trash.manageTrash :
									false;

								// only site admins can access content configuration
								if (!pxAuthService.isSiteAdmin && !hasTrashPriv) {
									return {
										to: 'content.home'
									};
								}
							}])
						}
					})
					.state('documentTrash.home', {
						url: '',
						views: {
							'app': { template: '<smb-trash />' }
						}
					})
					.state('import', {
						abstract: true,
						url: '/import',
						views: {
							'main': { template: '<smb-main></smb-main>' }
						}
					})
					.state('import.contentTypeGroups', {
						url: '',
						views: {
							'app': { template: '<smb-content-type-groups/>' }
						}
					})
					.state('import.contentTypeGroups.contentTypes', {
						url: '/:groupId',
						views: {
							'app@import': {
								template: function (params) {
									return '<smb-content-types group-id="' + params.groupId + '" />';
								}
							}
						}
					})
					.state('import.contentTypeGroups.contentTypes.content', {
						url: '/:typeId',
						views: {
							'app@import': {
								template: function (params) {
									return '<smb-content content-type-group-id="' + params.groupId + '" content-type-id="' + params.typeId + '" />';
								}
							}
						}
					})
					.state('search', {
						abstract: true,
						url: '/search',
						views: {
							'main': { template: '<smb-main></smb-main>' }
						}
					})
					.state('search.contentTypeGroups', {
						url: '',
						views: {
							'app': { template: '<smb-content-type-groups-search/>' }
						}
					})
					.state('search.contentTypeGroups.contentTypes', {
						url: '/:groupId',
						views: {
							'app@search': {
								template: function (params) {
									return '<smb-content-types-search group-id="' + params.groupId + '" />';
								}
							}
						}
					})
					.state('search.contentTypeGroups.contentTypes.groupSearch', {
						url: '/all',
						views: {
							'app@search': {
								template: function (params) {
									return '<smb-content-type-group-search group-id="' + params.groupId + '" />';
								}
							}
						}
					})
					.state('search.contentTypeGroups.contentTypes.groupSearch.results', {
						url: '/results',
						views: {
							'app@search': {
								template: function (params) {
									return '<smb-content-type-group-search-results group-id="' + params.groupId + '" />';
								}
							}
						}
					})
					.state('search.contentTypeGroups.contentTypes.search', {
						url: '/:typeId',
						views: {
							'app@search': {
								template: function (params) {
									return '<smb-content-search group-id="' + params.groupId + '" type-id="' + params.typeId + '" />';
								}
							}
						}
					})
					.state('search.contentTypeGroups.contentTypes.search.results', {
						url: '/results',
						views: {
							'app@search': {
								template: function (params) {
									return '<smb-content-search-results group-id="' + params.groupId + '" type-id="' + params.typeId + '" />';
								}
							}
						}
					})
					.state('todo', {
						abstract: true,
						url: '/mytodolist',
						views: {
							'main': { template: '<smb-main></smb-main>' }
						}
					})
					.state('todo.list', {
						url: '',
						views: {
							'app': { template: '<smb-to-do-list></smb-to-do-list>'}
						}
					})
					.state('document', {
						url: '/documentgroups/:documentGroupId/documenttypes/:documentTypeId/documents/:documentId',
						abstract: true,
						views: {
							main: {
								template: '<smb-main></smb-main>'
							}
						}
					})
					.state('document.view', {
						url: '',
						views: {
							app: {
								template: function(params) {
									return '<smb-document-view previous-state="' + params.previous + '" document-group-id="' + params.documentGroupId + '" document-type-id="' + params.documentTypeId + '" document-id="' + params.documentId + '"></smb-document-view>';
								}
							}
						}
					});

				function inject() {
					var injectionArgs = arguments;
					return function injectableWrapper($injector) {
						$injector = $injector || angular.injector(['ng']);

						return $injector.invoke.apply($injector, injectionArgs);
					};
				}
			}
		])
		// This is from the demo and will eventually be removed. We will need to discuss theming items.
		// This maps a number to a color and is used in various components that list items to color them by
		// the list index.
		/* jshint maxcomplexity:12 */
		.filter('colorFilter', function () {
			return function (position) {
				position = (position % 11) + 1;
				switch (position) {
					case 1:
						return 'blue';
					case 2:
						return 'green';
					case 3:
						return 'lightBlue';
					case 4:
						return 'yellow';
					case 5:
						return 'onbaseBlue';
					case 6:
						return 'lightGreen';
					case 7:
						return 'sharebaseBlue';
					case 8:
						return 'orange';
					case 9:
						return 'gray';
					case 10:
						return 'darkGreen';
					case 11:
						return 'yellow';
					default:
						return 'green';
				}
			};
		})
		// Removes div elements and precedes the text that was previously
		// contained in the div with a br element
		.filter('lineBreak', function() {
			return function(text) {
				return text
					.split('<div><br></div>').join('<br>')
					.split('<div>').join('<br>')
					.split('</div>').join('');
			};
		})
		// Escapes html in text so it can be used with the ng-bind-html directive
		.filter('trustHTML', ['$sce', function($sce) {
			return function(htmlCode) {
				return $sce.trustAsHtml(htmlCode);
			};
		}])
		.directive('smbMain',
		[
			MainDirective
		])
		.controller('MainController',
		[
			'$window',
			'$state',
			'smbToDoListDataStore',
			'smbPanelDetailsDataStore',
			'smbToolbarService',
			'pxAuthService',
			'pxEnvironmentService',
			MainController
		]);

	var templateUrl = require('./app.template');
	function MainDirective() {
		return {
			restrict: 'E',
			controller: MainController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {}
		};
	}

	function MainController($window, $state, smbToDoListDataStore, smbPanelDetailsDataStore, smbToolbarService, pxAuthService, pxEnvironmentService) {
		var vm = this;		
		vm.todoListDS = smbToDoListDataStore;

		// Wrap in check to make sure user is authenticated, because this controller
		// may be created before user logs in
		if (pxAuthService.isAuthenticated) {
			vm.todoListDS.loadCount();
			vm.todoListDS.init();
		}

		vm.logout = logout;
		vm.openLink = openLink;
		vm.isUserAdmin = isUserAdmin;
		vm.isContentAdmin = isContentAdmin;
		vm.smbToolbarService = smbToolbarService;
		vm.panelDetailsDS = smbPanelDetailsDataStore;
		vm.pxEnvironmentService = pxEnvironmentService;
		vm.userName = pxAuthService.displayName;
		vm.privileges = pxAuthService.privileges;
		vm.isSiteAdmin = pxAuthService.isSiteAdmin;

		// flag that determines if the mobile navigation
		// via a sidebar is open or closed
		vm.mobileNavOpen = false;

		vm.onClickBackArrow = onClickBackArrow;

		function isUserAdmin() {
			return smbToolbarService.hasUserAdminRights;
		}

		function isContentAdmin() {
			return smbToolbarService.hasContentAdminRights;
		}

		function logout() {
			pxAuthService.invalidateLogin();
			vm.todoListDS.clear();
			$state.go('login');
		}

		function onClickBackArrow() {
			$state.go(vm.smbToolbarService.backArrowState, vm.smbToolbarService.backArrowStateParams);
		}

		function openLink(url) {
			$window.open(url,'_blank');
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/_app/app.js
// module id = 62
// module chunks = 1